(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    class ProductDescription extends HTMLElement {
    connectedCallback() {
      const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
      if (!target) return;
      target.addEventListener('variant:update', this.updateDescription);
    }

    disconnectedCallback() {
      const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
      if (!target) return;
      target.removeEventListener('variant:update', this.updateDescription);
    }

    updateDescription = (event) => {
      if (!(event instanceof Event) || !(event.target instanceof HTMLElement)) return;
      const variantUpdateEvent = /** @type {CustomEvent} */ (event);
      const detail = variantUpdateEvent.detail;
      if (!detail || !detail.data || !detail.data.html) return;

      if (detail.data.newProduct) {
        this.dataset.productId = detail.data.newProduct.id;
      } else if (event.target.dataset.productId !== this.dataset.productId) {
        return;
      }

      const newDescription = detail.data.html.querySelector(`product-description[data-block-id="${this.dataset.blockId}"]`);
      if (!(newDescription instanceof HTMLElement)) return;
      this.innerHTML = newDescription.innerHTML;
    };
  }

  if (!customElements.get('product-description')) {
    customElements.define('product-description', ProductDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    class ProductDescription extends HTMLElement {
    connectedCallback() {
      const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
      if (!target) return;
      target.addEventListener('variant:update', this.updateDescription);
    }

    disconnectedCallback() {
      const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
      if (!target) return;
      target.removeEventListener('variant:update', this.updateDescription);
    }

    updateDescription = (event) => {
      if (!(event instanceof Event) || !(event.target instanceof HTMLElement)) return;
      const variantUpdateEvent = /** @type {CustomEvent} */ (event);
      const detail = variantUpdateEvent.detail;
      if (!detail || !detail.data || !detail.data.html) return;

      if (detail.data.newProduct) {
        this.dataset.productId = detail.data.newProduct.id;
      } else if (event.target.dataset.productId !== this.dataset.productId) {
        return;
      }

      const newDescription = detail.data.html.querySelector(`product-description[data-block-id="${this.dataset.blockId}"]`);
      if (!(newDescription instanceof HTMLElement)) return;
      this.innerHTML = newDescription.innerHTML;
    };
  }

  if (!customElements.get('product-description')) {
    customElements.define('product-description', ProductDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
